// extracted by css-extract-rspack-plugin
export default {"cls1":"WinBackPing-cls1_jqg","cls2":"WinBackPing-cls2_biZ WinBackPing-cls1_jqg"};